import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth0 } from "@auth0/auth0-react";



export const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { logout } = useAuth0();

    const handleHomeClick = () => {
        navigate('/');
    };

    const handleBackClick = () => {
        navigate(-1);
    };

    const handleLogoutClick = () => {
        logout({ logoutParams: { returnTo: `${window.location.origin}/login` } })
    };

    return (

        <header className='bg-orange h-[64px] px-8 w-full flex flex-row'>
            <div className='flex-1'>
                <Link to='/'>
                    <img className="h-[48px] w-auto" src='https://www.bostonequipment.com/images/logo.png' alt='Logo'/>
                </Link>
            </div>
            <div className="flex flex-1 justify-end items-center gap-6">
                {location.pathname !== '/' && (
                    <>
                        <Link to='/'>
                            <img
                                src='/resources/images/home.png'
                                className="size-8"
                                alt='Home'
                                onClick={handleHomeClick}
                            />
                        </Link>
                        <button onClick={handleBackClick}>
                            <img
                                src='/resources/images/back.png'
                                className="size-8"
                                alt='Back'
                            />
                        </button>
                        <button onClick={handleLogoutClick}>
                            <img
                                src='/resources/images/power-off.png'
                                className="size-8"
                                alt='Back'
                            />
                        </button>
                    </>
                )}
            </div>
        </header>



    );
};
